import { css } from '@emotion/react';

export const sidebar = css`
  border-right: 1px solid #e5e5e5;
  background: white;
  width: 100px;
  padding-top: 10px;
  height: 100%;
  overflow-y: auto;
`;
